export const dashboard = {
  chat: {
    title: "Chat",
    description:
      "Acesse nosso playground de Chat para testar uma variedade de modelos de LLMs.",
    button: "Chat Básico",
    button2: "Chat Comparativo",
    chatInterface: "Interface de Chat",
    basicChat: "Chat Básico",
    compareChat: "Chat Comparativo",
  },
  credits: {
    title: "Financeiro e Uso",
    description: "Gerencie suas compras de créditos.",
    addCredits: "Adicionar Saldo",
    viewPayments: "Ver Pagamentos",
    viewUsage: "Detalhes de Uso",
  },
  character: {
    title: "Personagens",
    description:
      "Crie e personalize personagens de IA para interações especializadas.",
    newCharacter: "Novo Personagem",
    viewCharacters: "Ver Personagens",
  },
  agent: {
    title: "Agentes",
    description:
      "Configure e implante agentes de IA para tarefas e fluxos de trabalho customizados.",
    viewAgents: "Ver Agentes",
    newAgent: "Novo Agente",
  },
  users: {
    title: "Utilizadores",
    description:
      "Gerencie contas de sub-usuários, que podem usar seus Agentes.",
    viewUsers: "Ver Usuários",
    newUser: "Novo Usuário",
  },
  settings: {
    title: "Configurações e Conta",
    description: "Gerencie suas configurações de conta, perfil, chave de API.",
    settings: "Configurações",
    profile: "Perfil",
    affiliate: "Programa de Afiliados",
  },
  community: {
    title: "Comunidade",
    description: "Solicite funcionalidades ou bata um papo nerd no Discord.",
    viewFeatures: "Quadro de Funcionalidades",
    viewDiscord: "Discord",
  },
  support: {
    title: "Suporte",
    description: "Solicite suporte ou entre em contato conosco.",
    viewSupport: "Atendimento ao Cliente",
    viewContact: "Contato",
  },
};
